const DEFAULT_AUTH_MODE = import.meta.env.DEV ? "mock" : "real";
const AUTH_MODE = String(import.meta.env.VITE_TIKTOK_AUTH_MODE || DEFAULT_AUTH_MODE).trim().toLowerCase();
const MOCK_OPEN_ID = String(import.meta.env.VITE_TIKTOK_MOCK_OPEN_ID || "tiktok_test_user_001").trim();
const MOCK_DISPLAY_NAME = String(import.meta.env.VITE_TIKTOK_MOCK_DISPLAY_NAME || "TikTok Test Player 01");
const MOCK_AVATAR_URL = String(import.meta.env.VITE_TIKTOK_MOCK_AVATAR_URL || "");
const MARKER = "bricksbeater_tiktok_session_v1";
let inFlight = null;
export const tiktokAuthMode = () => AUTH_MODE;
function game(){ return globalThis.TTMinis?.game || null; }
function invoke(name, options={}){
  const fn=game()?.[name];
  if(typeof fn!=="function") throw new Error(`TTMinis.game.${name} is unavailable`);
  return new Promise((resolve,reject)=>{
    let done=false; const ok=v=>{if(!done){done=true;resolve(v||{})}}; const bad=e=>{if(!done){done=true;reject(e instanceof Error?e:new Error(String(e?.errMsg||e||"TikTok SDK failed")))}};
    try{ const r=fn.call(game(),{...options,success:ok,fail:bad}); if(r?.then) r.then(ok,bad); else if(r?.code) ok(r); }catch(e){bad(e)}
  });
}
function codeOf(r,label){const c=String(r?.code||"").trim(); if(!c) throw new Error(`${label} returned no code`); return c;}
function getMarker(){try{return sessionStorage.getItem(MARKER)||""}catch{return ""}}
function setMarker(v){try{sessionStorage.setItem(MARKER,v)}catch{}}
export function clearTikTokSessionMarker(){try{sessionStorage.removeItem(MARKER)}catch{}}
export async function createTikTokSession(raw,{force=false}={}){
  const marker=`${AUTH_MODE}:${AUTH_MODE==="mock"?MOCK_OPEN_ID:"sdk"}`;
  if(!force&&getMarker()===marker) return null;
  if(inFlight) return inFlight;
  inFlight=(async()=>{
    let p;
    if(AUTH_MODE==="real"){
      const r=await invoke("login"); p=await raw("/api/auth/tiktok/login",{method:"POST",body:{code:codeOf(r,"TTMinis.game.login()")}});
    }else if(AUTH_MODE==="mock"){
      p=await raw("/api/auth/tiktok/mock-login",{method:"POST",body:{open_id:MOCK_OPEN_ID,display_name:MOCK_DISPLAY_NAME,...(MOCK_AVATAR_URL?{avatar_url:MOCK_AVATAR_URL}:{})}});
    }else throw new Error(`Unsupported VITE_TIKTOK_AUTH_MODE=${AUTH_MODE}`);
    setMarker(marker); return p;
  })();
  try{return await inFlight}finally{inFlight=null}
}
export async function authorizeTikTokBasicProfile(raw){
  if(AUTH_MODE!=="real") return raw("/api/auth/tiktok/profile",{method:"GET"});
  const r=await invoke("authorize",{scope:"user.info.basic"});
  return raw("/api/auth/tiktok/profile",{method:"POST",body:{code:codeOf(r,"TTMinis.game.authorize()")}});
}
